import dayjs from 'dayjs';

export default value => dayjs(value).unix();
